import React, { useState, useEffect } from 'react'
import { get } from 'lodash'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { sendErrorReport, displayValue, formatDate } from 'shared/helpers'
import { Button, IconCheckmark, IconDisabled, List } from 'shared/components'
import AddOrdersModal from './AddOrdersModal'
import { fetchAccountOrdersList } from 'src/customer/actions'
import RemoveOrdersModal from './RemoveOrdersModal'
import './styles.scss'

const OrdersTab = () => {
  const history = useHistory()
  const { accountId } = useParams()
  const companyID = useSelector(state => get(state, 'company.details.id'))
  const [ordersLoading, setOrdersLoading] = useState(true)
  const [ordersList, setOrdersList] = useState([])
  const [isAddOrderToCustomerAccountModalOpen, setAddOrderToCustomerAccountModalOpen] = useState(
    false
  )
  const [
    isRemoveOrderFromCustomerAccountModalOpen,
    setRemoveOrderFromCustomerAccountModalOpen
  ] = useState(false)

  useEffect(() => {
    setOrdersLoading(true)
    fetchAccountOrdersList(companyID, accountId)
      .then(res => {
        setOrdersList(get(res, 'data.results'))
        setOrdersLoading(false)
      })
      .catch(err => {
        sendErrorReport(err, 'Cannot get customer account orders')
        setOrdersLoading(false)
      })
  }, [companyID, accountId])

  const redirectToOrderPage = rowData => {
    const orderID = get(rowData, 'original.id')
    history.push(`/${companyID}/orders/${orderID}`)
  }

  const submitOrdersManipulation = value => {
    if (value === 'refreshOrders')
      fetchAccountOrdersList(companyID, accountId)
        .then(res => {
          setOrdersList(get(res, 'data.results'))
          setOrdersLoading(false)
        })
        .catch(err => {
          sendErrorReport(err, 'Cannot get customer account orders')
          setOrdersLoading(false)
        })
    setAddOrderToCustomerAccountModalOpen(false)
    setRemoveOrderFromCustomerAccountModalOpen(false)
  }

  return (
    <div className='orders-tab'>
      <div className='orders-tab-buttons'>
        <Button
          theme='default'
          size='sm'
          onClick={() => setAddOrderToCustomerAccountModalOpen(true)}
        >
          {__('Add orders')}
        </Button>
        <Button
          theme='error'
          size='sm'
          onClick={() => setRemoveOrderFromCustomerAccountModalOpen(true)}
        >
          {__('Remove orders')}
        </Button>
      </div>
      {isAddOrderToCustomerAccountModalOpen && (
        <AddOrdersModal closeForm={submitOrdersManipulation} />
      )}
      {isRemoveOrderFromCustomerAccountModalOpen && (
        <RemoveOrdersModal closeForm={submitOrdersManipulation} />
      )}
      <List
        clickable
        columns={[
          {
            accessor: 'created_at',
            Header: __('Created on'),
            Cell: cellInfo => formatDate(cellInfo.value),
            width: 180
          },
          {
            accessor: 'store_id',
            Header: __('Order ID'),
            Cell: cellInfo => displayValue(cellInfo.value),
            minWidth: 200
          },
          {
            accessor: 'campaign_params',
            Header: __('Campaign parameters'),
            Cell: cellInfo => displayValue(cellInfo.value)
          },
          {
            accessor: 'download_id',
            Header: __('Download ID'),
            Cell: cellInfo => displayValue(cellInfo.value)
          },
          {
            accessor: 'has_active_licenses',
            Header: __('Has active licenses'),
            headerClassName: 'text-center',
            className: 'text-center',
            Cell: cellData =>
              cellData.value ? (
                <IconCheckmark color='#10ac84' height='14px' />
              ) : (
                <IconDisabled color='red' height='14px' />
              )
          }
        ]}
        data={ordersList || []}
        loading={ordersLoading}
        minRows={2}
        handleClick={rowData => redirectToOrderPage(rowData)}
      />
    </div>
  )
}

export default OrdersTab
